import { render, staticRenderFns } from "./ChecklistChip.vue?vue&type=template&id=5fe40d24&scoped=true"
import script from "./ChecklistChip.vue?vue&type=script&lang=js"
export * from "./ChecklistChip.vue?vue&type=script&lang=js"
import style0 from "./ChecklistChip.vue?vue&type=style&index=0&id=5fe40d24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe40d24",
  null
  
)

export default component.exports